export const FLY_NEW_ROUNDTRIP_DISPLAY_FOR_INT_FLIGHTS_KEY = 'fly_new_roundtrip_display_for_int_flights'

const EXPERIMENT_REGEX = /(fly_[^,=\s]+)\s*=\s*([^,=\s]+)/g

function decodeExperimentRaw(raw: string): string {
  try {
    return decodeURIComponent(raw)
  } catch {
    return raw
  }
}

function parseFlyExperimentsFromKeyValue(source: string): Record<string, string> {
  const experiments: Record<string, string> = {}

  for (const match of source.matchAll(EXPERIMENT_REGEX)) {
    experiments[match[1]] = match[2]
  }

  if (Object.keys(experiments).length > 0) {
    return experiments
  }

  return Object.fromEntries(
    source
      .split(',')
      .map((pair) => pair.trim())
      .filter(Boolean)
      .map((pair) => {
        const [key, ...rest] = pair.split('=')
        return [key?.trim() || '', rest.join('=').trim()] as [string, string]
      })
      .filter(([key, value]) => key.startsWith('fly_') && Boolean(value))
  )
}

export function parseXExperiments(source: string): Record<string, string> {
  if (!source) return {}

  try {
    const parsed: unknown = JSON.parse(source)
    if (typeof parsed === 'object' && parsed !== null) {
      const experiments: Record<string, string> = {}
      for (const [key, value] of Object.entries(parsed)) {
        if (key.startsWith('fly_') && typeof value === 'string') {
          experiments[key] = value
        }
      }
      if (Object.keys(experiments).length > 0) {
        return experiments
      }
    }
  } catch {
    // fall through to key=value format
  }

  return parseFlyExperimentsFromKeyValue(source)
}

export function mergeXExperiments(headerSource?: string | null, cookieSource?: string | null): Record<string, string> {
  const fromHeader = headerSource ? parseXExperiments(headerSource) : {}
  const fromCookie = cookieSource ? parseXExperiments(cookieSource) : {}

  return { ...fromHeader, ...fromCookie }
}

export function getXExperimentsFromCookieHeader(cookieHeader: string): Record<string, string> {
  const cookieValue = cookieHeader
    .split(';')
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith('x-experiments-cookie='))
    ?.slice('x-experiments-cookie='.length)

  if (!cookieValue) return {}

  return parseXExperiments(decodeExperimentRaw(cookieValue))
}

export function getXExperimentsFromDocument(): Record<string, string> {
  if (typeof document === 'undefined') return {}

  return getXExperimentsFromCookieHeader(document.cookie)
}

export function resolveXExperimentsFromRequest(options: {
  xExperimentsHeader?: string | null
  xExperimentsCookieHeader?: string | null
  cookieHeader?: string | null
}): Record<string, string> {
  const headerSource = options.xExperimentsHeader || options.xExperimentsCookieHeader || null

  let browserCookieSource: string | null = null
  if (options.cookieHeader) {
    const cookieValue = options.cookieHeader
      .split(';')
      .map((cookie) => cookie.trim())
      .find((cookie) => cookie.startsWith('x-experiments-cookie='))
      ?.slice('x-experiments-cookie='.length)

    if (cookieValue) {
      browserCookieSource = decodeExperimentRaw(cookieValue)
    }
  }

  return mergeXExperiments(headerSource, browserCookieSource)
}

export function shouldAppendIsNewRtParam(params: { isWingie: boolean; flightType?: string; tripValue?: string; geoTrip?: string; experimentVariant?: string }): boolean {
  return (
    params.isWingie &&
    params.flightType === 'round-trip' &&
    params.tripValue === 'international' &&
    params.geoTrip === 'international' &&
    params.experimentVariant?.toUpperCase() === 'B'
  )
}
